import { Accordion, AccordionSummary, Grid2, Typography } from "@mui/material";
import { useState } from "react";
import { client } from "../../support/utils";
import { ethereum } from "thirdweb/chains";
import { useReadContract } from "thirdweb/react";
import { getContract } from "thirdweb";

export const TokenAcccordionDetailsMethod = ({
  token: { address, isCodeVerified },
  method: { key: bytes, sigs },
}) => {
  const [expanded] = useState(false);
  const contract = getContract({
    client,
    address,
    chain: ethereum,
  });

  const isArgLess =
    sigs[0].signature.includes("()") ||
    (isCodeVerified && sigs[0].returnArgs !== "void");
  const returnValues =
    sigs[0].returnArgs !== ""
      ? sigs.map((sig) => sig.returnArgs)
      : ["string", "uint256", "address"];
  if (returnValues.length < 2) returnValues.push("bytes");
  const { data: dataOne } = useReadContract({
    contract,
    method: `function ${sigs[0].signature} returns (${returnValues[0]})`,
    params: [],
  });

  const { data: dataTwo } = useReadContract({
    contract,
    method: `function ${sigs[0].signature} returns (${returnValues[1]})`,
    params: [],
  });

  const { data: dataThree } = useReadContract({
    contract,
    method: `function ${sigs[0].signature} returns (${returnValues[2]})`,
    params: [],
  });
  const result = dataOne || dataTwo || dataThree;
  // dataString ||
  // (dataAddress &&
  // dataAddress.length > 30 &&
  // !(dataAddress.includes("00000000000") || dataAddress.endsWith("dEaD"))
  //   ? dataAddress
  //   : null) ||
  // (dataInt ? BigInt(dataInt).toString() : "");

  //   useEffect(() => {
  //     console.log(dataString, dataInt);
  //   }, [dataInt, dataString]);
  return (
    <Accordion
      disableGutters={true}
      square={true}
      elevation={1}
      expanded={expanded}
      sx={{ userSelect: "text" }}
    >
      <AccordionSummary
        sx={{ pointerEvents: "none", userSelect: "text" }}
        // expandIcon={
        //   <Button
        //     sx={{ pointerEvents: "auto" }}
        //     onClick={() => setExpanded((prev) => !prev)}
        //   >
        //     <ExpandMoreIcon />
        //   </Button>
        // }
      >
        <Grid2 container columns={16} sx={{ width: "100%" }}>
          <Grid2 size={{ lg: 2, md: 3, sm: 3, xs: 4 }}>
            <Typography variant="subtitle2">{bytes}</Typography>
          </Grid2>
          <Grid2 size={"grow"}>
            <Typography variant="subtitle2">{sigs[0].signature}</Typography>
          </Grid2>
          <Grid2
            size={{ lg: "grow", md: "grow", sm: 16, xs: 16 }}
            justifyItems={"end"}
          >
            <Typography variant="subtitle2">
              {isArgLess &&
                (typeof result === "bigint"
                  ? BigInt(result).toString()
                  : result)}
            </Typography>
          </Grid2>
        </Grid2>
      </AccordionSummary>
      {/* <AccordionDetails>
        {"<TokenAccordionDetails token={token} open={expanded} />"}
      </AccordionDetails> */}
    </Accordion>
  );
};

export const TokenAcccordionDetailsMethodMobile = ({
  method: { key: bytes, sigs },
}) => {
  const [expanded] = useState(false);

  return (
    <Accordion
      disableGutters={true}
      square={true}
      elevation={1}
      expanded={expanded}
      sx={{ userSelect: "text" }}
    >
      <AccordionSummary sx={{ pointerEvents: "none", userSelect: "text" }}>
        <Grid2 container columns={16} sx={{ width: "100%" }}>
          <Grid2 size={{ lg: 2, md: 3, sm: 3, xs: 4 }}>
            <Typography variant="subtitle2">{bytes}</Typography>
          </Grid2>
          <Grid2 size={"grow"}>
            <Typography variant="subtitle2">{sigs[0].signature}</Typography>
          </Grid2>
        </Grid2>
      </AccordionSummary>
    </Accordion>
  );
};
